import React from 'react';
import { ppData } from '../configs/ppData.config';
import { useSEOKeywords } from '../hooks/useSEOKeywords';
import { getDynamicSEODescription } from '../utils/getDynamicSEODescription';
import { LABEL_HOT_DEAL } from '../constants/labelValues';
import { layoutValues } from '../configs/options';
import { useActiveOrFirstVariant } from '../hooks/useActiveOrFirstVariant';
const { originalTitle, sku, images, reviews, labels, options, variants } = ppData;
const [layouts] = layoutValues;
const isHotDeal = labels?.includes(LABEL_HOT_DEAL) === true;
export const JsonLd = React.memo(() => {
    const date = new Date();
    const image = images[layouts[0].value].rooms[0].url;
    const searchParams = new URLSearchParams(window.location.search);
    const [kw1] = useSEOKeywords(searchParams);
    const activeVariant = useActiveOrFirstVariant(searchParams);
    const data = {
        '@context': 'https://schema.org/',
        '@type': 'Product',
        name: originalTitle,
        image,
        description: ppData.staticDescription !== undefined ? ppData.staticDescription : getDynamicSEODescription(kw1).join(' '),
        sku,
        brand: {
            '@type': 'Organization',
            name: 'ElephantStock'
        },
        mpn: sku,
        offers: variants.map(({ price, optionNames, optionValues }) => {
            return {
                '@type': 'Offer',
                url: `${window.location.origin}${window.location.pathname}?${optionValues.map((value, i) => `${i > 0 ? '&' : ''}${options[i].searchParamKey}=${value}`).join('')}`,
                name: optionNames.join(' / '),
                sku,
                price: Number(((isHotDeal ? price * 0.85 : price) / 100).toFixed(2)),
                priceCurrency: 'USD',
                priceValidUntil: date.getFullYear() + 1,
                itemCondition: 'https://schema.org/NewCondition',
                availability: 'https://schema.org/InStock',
                itemOffered: {
                    '@type': 'VisualArtwork',
                    name: originalTitle
                },
                seller: {
                    '@type': 'Organization',
                    name: 'ElephantStock'
                }
            };
        }),
        hasMerchantReturnPolicy: {
            '@type': 'MerchantReturnPolicy',
            merchantReturnLink: 'https://www.elephantstock.com/blogs/help-center/our-return-policy',
            merchantReturnDays: 60,
            refundType: 'FullRefund, ExchangeRefund'
        },
        ...reviews !== undefined && {
            aggregateRating: {
                '@type': 'AggregateRating',
                ratingValue: reviews.avgRating,
                reviewCount: reviews.nbReviews
            },
            Review: reviews.items.map(({ username, date, rating, review_text }) => ({
                '@type': 'Review',
                author: {
                    '@type': 'Person',
                    name: username
                },
                datePublished: date,
                Description: '',
                reviewRating: {
                    '@type': 'Rating',
                    bestRating: 5,
                    ratingValue: rating,
                    worstRating: 1
                },
                reviewBody: review_text
            }))
        }
    };
    const jsonScript = document.createElement('script');
    jsonScript.type = 'application/ld+json';
    jsonScript.textContent = JSON.stringify(data);
    const priceMeta = document.createElement('meta');
    priceMeta.setAttribute('property', 'og:price:amount');
    priceMeta.content = ((isHotDeal ? activeVariant.price * 0.85 : activeVariant.price) / 100).toFixed(2);
    const currencyMeta = document.createElement('meta');
    currencyMeta.setAttribute('property', 'og:price:currency');
    currencyMeta.content = 'USD';
    document.head.append(jsonScript, priceMeta, currencyMeta);
    return null;
});
